import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ItinerariesManager from "@/shared/ItinerariesManager";

// Gestão de percursos para Assessores Espirituais (área de sócios).
export default function MemberItinerariesManage() {
  return (
    <section className="container-page py-12 lg:py-16" data-testid="member-itineraries-manage-page">
      <Link to="/membros/percursos" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]" data-testid="manage-back">
        <ArrowLeft className="h-3.5 w-3.5" /> Voltar aos percursos
      </Link>
      <div className="overline mt-6">Assessor Espiritual</div>
      <h1 className="display-heading text-4xl sm:text-5xl mt-3">Gestão de percursos.</h1>
      <span className="accent-rule mt-6 block" />
      <div className="mt-8">
        <ItinerariesManager />
      </div>
    </section>
  );
}
